import { ButtonBack } from 'components/ButtonBack';
import { ButtonGroup } from 'components/Form/ButtonGroup';
import { Toast } from 'components/Toast';
import { ToastValues } from 'components/ToastValues';
import { useAuth } from 'hooks/auth';
import { useModal } from 'hooks/modal';
import { useSpinner } from 'hooks/spinner';
import { useToast } from 'hooks/toast';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import api from 'services/api';
import { nextStep } from 'store/modules/dataIndexStep/action';
import { TiposSituacoes } from 'utils/enum';
import { formaPagamentoSelecionadaProps, protocoloProps } from 'utils/types';
import boleto from 'assets/img/boleto.png';

import { Container, ContentImage, ContentInfo, ContentErro, ButtonGerarBoleto } from '../Boleto/styles';
import { FormStepper } from 'components/FormWithSteps/FormStepper';
import { FormStep } from 'components/FormWithSteps/FormStep';
import ButtonLink from 'components/ButtonLink';

interface dataBoletosProps {
  Boletos: dataBoletoProps[]
}

interface dataBoletoProps {
  Valor: number;
  Vencimento: string;
  ValorTaxa: number;
  LinhaDigitavel: string;
  CodigoBarrasBase64: string;
  UrlBoleto: string;
}

const schemaDataBoleto = {
  Valor: 0,
  Vencimento: '',
  ValorTaxa: 0,
  LinhaDigitavel: '',
  CodigoBarrasBase64: '',
  UrlBoleto: ''
};

export const Boleto: React.FC = () => {
  const [dataBoleto, setDataBoleto] = useState<dataBoletoProps>();
  const [verificarSituacao, setVerificarSituacao] = useState<any>();
  const [erroProtocolo, setErroProtocolo] = useState(false);

  const protocoloPagamento = JSON.parse(
    sessionStorage.getItem('@CheckoutWeb:protocoloPagamento') ?? '',
  ) as protocoloProps;

  const selectPayment = JSON.parse(
    sessionStorage.getItem('@CheckoutWeb:formaPagamento') ?? '',
  ) as formaPagamentoSelecionadaProps;

  const { loading, setLoading } = useSpinner();
  const { showModal } = useModal();
  const { getTotalSeconds } = useAuth();
  const { addToast } = useToast();

  const dispatch = useDispatch();

  const history = useHistory();

  const pathPagamento = history.location.pathname;

    useEffect(() => {
      sessionStorage.setItem('@CheckoutWeb:escolheuForma', 'true');
    }, []);

  const resetarPagamento = useCallback(() => {
    window.stop();
    clearTimeout(verificarSituacao);
    setVerificarSituacao({});
    history.goBack();
  }, [history, verificarSituacao]);

  const handleSituationGuid = useCallback(async () => {
    if (pathPagamento !== '/pagamento') {
      clearTimeout(verificarSituacao);
      setVerificarSituacao({});
      return;
    }

    await api
      .get(`Protocolo/${protocoloPagamento.GuidProtocolo}/situacao`)
      .then(result => {
        const { Data } = result.data;

        if (Data.SituacaoProtocolo === TiposSituacoes.concluido) {
          clearTimeout(verificarSituacao);
          dispatch(nextStep());
          setVerificarSituacao({});
        }

        if (
          Data.SituacaoProtocolo === TiposSituacoes.iniciado ||
          Data.SituacaoProtocolo === TiposSituacoes.emAndamento
        ) {
          setVerificarSituacao(
            setTimeout(() => {
              handleSituationGuid();
            }, 10000),
          );
        }
      })
      .catch((error: Error) => {
        if (error.message === 'Request aborted') {
          return;
        }
        resetarPagamento();
        addToast({
          type: 'danger',
          title: 'Atenção',
          description: error.message,
        });
      });
  }, [addToast, protocoloPagamento.GuidProtocolo, showModal, dispatch]);

  const handleGetDataBoleto = useCallback(async () => {
    setLoading(true);
    setDataBoleto(schemaDataBoleto);
    clearTimeout(verificarSituacao);
    setVerificarSituacao({});
    await api
      .post(
        `/Boleto`,  {
          "GuidProtocolo": protocoloPagamento.GuidProtocolo,
          "IdSistemaOrigem": 18
        }
      )
      .then(result => {
        if(!result.data)
          setErroProtocolo(true);
        setDataBoleto(result.data[0]);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        window.stop();
        clearTimeout(verificarSituacao);
        setVerificarSituacao({});
        setErroProtocolo(true);
        handleSituationGuid()
        console.log(error);
        addToast({
          type: 'danger',
          title: 'Atenção',
          description: error.message,
        });
      });
  }, [
    setLoading,
    protocoloPagamento.GuidProtocolo,
    selectPayment.Id,
    handleSituationGuid,
    addToast,
  ]);

  useEffect(() => {
    clearTimeout(verificarSituacao);
    setVerificarSituacao({});
  }, []);

  useEffect(() => {
    getTotalSeconds();
  }, [getTotalSeconds]);

  useEffect(() => {
    handleGetDataBoleto();
  }, [handleGetDataBoleto]);

  return (
        <FormStep> 
          <Container>
            <div>
              {dataBoleto?.LinhaDigitavel ? (
                <>
                  <div className="mb-4">
                    <ToastValues payment={selectPayment} valorTotal={dataBoleto.Valor} />
                  </div>
                  <ContentImage>
                    <ContentInfo>
                      <p id="info">Pagar com boleto pode demorar até</p> <p><b>3 dias úteis</b> para processar pagamento</p>
                    </ContentInfo>
                    <div id="mainContent">
                        {/* <img
                          src={`data:image/png;base64,${dataBoleto.CodigoBarrasBase64}`}
                          alt="qrCode"
                          style={{ width: '800px', height: '200px' , transform: 'scaleX(1.0) scaleY(1.0)', paddingTop: 36, paddingBottom: 36}}
                        /> */}
                        <img src={boleto} alt="iconNotFound" />
                      <div className="d-flex justify-content-center mb-3">
                        <button
                          type="button"
                          onClick={() => {
                            addToast({
                              type: 'info',
                              title: 'Atenção',
                              description: 'Linha digitável copiada com sucesso',
                            });
                            navigator.clipboard.writeText(dataBoleto.LinhaDigitavel);
                          }}
                        >
                          <b>COPIAR CÓDIGO DE BARRAS</b>
                        </button>
                      </div>
                        <button id='imprimirBoleto'
                          type="button"
                          onClick={() => {
                            window.open(dataBoleto.UrlBoleto, '_blank');
                          }}
                        >
                          <b>VISUALIZAR BOLETO</b>
                        </button>
                      
                    </div>
                  </ContentImage>
                  <ButtonGroup align="center">
                    <ButtonLink />
                  </ButtonGroup>
                </>
              ) : (
                <>
                  {!loading && erroProtocolo && (
                    <ContentErro>
                      <div>
                        <Toast
                          title="Atenção"
                          textInfo="Falha ao tentar gerar o Boleto, clique no botão abaixo para gerar um novo Boleto."
                          type="danger"
                        />

                        <ButtonGerarBoleto id='gerarBoleto' title="gerar boleto" onClick={handleGetDataBoleto}> GERAR BOLETO</ ButtonGerarBoleto>

                        <ButtonGroup>
                          <ButtonLink />
                        </ButtonGroup>
                      </div>
                    </ContentErro>
                  )}
                </>
              )}
            </div>
          </Container>
        </FormStep>    
  );
};
